import React, { Component } from 'react'
import { observer, inject } from "mobx-react"
import { containerStyle } from '../../utils/export-style';

import { LeftMenu } from '../../components/common/LeftMenu';
import { Box, Container, Grid } from '@mui/material';

import getClinic from '../../utils/api/Doctor/Clinic/GetClinic'

import { KlinikMenu } from '../../components/doktor/klinik/KlinikMenu';

class KlinikPage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            clinic: null,
            
        }
    }

    componentDidMount = async () => {
        if (!this.props.store.isLogin) {
            this.props.store.setLoadingBarStatus(true)
            this.props.history.push("/panel/kullanici-girisi");
        }else{
            this.props.store.setLoadingBarStatus(false)

            let clinicResponse = await getClinic(this.props.store.baseUrl, this.props.store.token, this.props.store.doctor[0].id)
            if(clinicResponse !== null && clinicResponse !== undefined){
                if(clinicResponse.status === 200){
                    this.setState({
                        clinic: clinicResponse.data
                    })
                }else if(clinicResponse.status === 401){
                    this.props.store.setUserLogout()
                    window.location.reload()
                }
            }
            
            this.props.store.setLoadingBarStatus(true)
        }
    }
 
    render() {

        return (
            <div className="container mps-container">
                <LeftMenu activePage={"Mis360"}/>
                <Box component="main" sx={{
                    ...containerStyle,
                    flexGrow: 1,
                    py: 8
                }} >
                    <Container maxWidth={false}>
                        <Grid container spacing={3}>
                            <Grid item lg={12} md={12} xl={12} xs={12}>
                                <KlinikMenu data={this.state.clinic}/>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </div>
        )
    }
}

export default inject("store")(observer(KlinikPage));
